<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="title">基本信息：</div>
      <el-form
        ref="dialogForm"
        :model="dialogForm"
        :rules="formRule"
        label-width="120px"
      >
        <el-form-item label="景区名称" prop="company_name">
          <el-input
            style="width: 220px"
            v-model="dialogForm.company_name"
            placeholder="请输入景区名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联5.0景区" prop="five_company_id">
          <el-select v-model="dialogForm.five_company_id" filterable placeholder="请选择5.0景区">
            <el-option
              v-for="item in storeList"
              :key="item.storeId"
              :label="item.storeName"
              :value="item.storeId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="titlas">
          <span class="title">活动坐标：</span>
          <span class="tips">请在地图内点击景区范围边框</span>
        </div>
        <el-form-item label="景区地图检索">
          <el-input placeholder="请输入景区" style="width: 200px;" v-model="dialogForm.app_map"/>
          <el-button type="primary" style="margin-left: 20px;" @click="getMap1Point">查询</el-button>
        </el-form-item>
        <el-form-item label="省/市/区：" prop="provinceCode">
          <div class="setCity">
            <el-select placeholder="请选择省份" v-model="dialogForm.provinceCode" clearable filterable @change="initProvince">
              <el-option v-for="item in province" :key="item.provice" :label="item.province"  @click.native="provinceChange(item)"
                :value="item.provice">
              </el-option>
            </el-select>
            <el-select placeholder="请选择城市" v-model="dialogForm.cityCode" clearable filterable @change="initCity">
              <el-option v-for="item in cityList" :key="item.adcode" :label="item.name" @click.native="cityChange(item)"
                :value="item.adcode">
              </el-option>
            </el-select>
            <!-- <el-select placeholder="请选择区县" v-model="dialogForm.districtCode" clearable filterable>
              <el-option v-for="(item, index) in areaList" :key="item.code" :label="item.area" @click.native="changeDistrict(item)"
                :value="item.code">
              </el-option>
            </el-select> -->
          </div>
        </el-form-item>
        
        <div class="map">
          <Map1 
            v-if="true"
            :load="getMap1AreaSt"
            :mapCenter="mapCenter"
            :zoom="16"
            :maxzoom="19"
            :minzoom="6"
            :islimit='true'>
          </Map1>
        </div>
        <template v-if="polygon.length">
          <div v-for="(item, index) in polygon" :key="index">
            <el-form-item :label="`活动坐标${index + 1}:`">
              <el-input
                style="width: 220px"
                :value = "`${item.lng + ',' + item.lat}`"
                placeholder="请输入景区名称"
                disabled
              ></el-input>
            </el-form-item>
          </div>
        </template>
        <el-form-item>
          <span class="dialog-footer">
            <el-button @click="reset">取消</el-button>
            <el-button type="primary" @click="submitForm('dialogForm')">提交</el-button>
          </span>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { createCompany, updateCompany, getCompanyList, delCompany } from "@/api/radio";
import Map1 from '@/components/map/map1'
// import { province } from '../../../static/province.js'
import { province } from '../../../static/procity.js'

export default {
  components: { Map1 },
  data() {
    return {
      province,
      mapCenter: [121.506427,31.245275],
      formRule: {
        company_name: {
          required: true,
          message: "请输入景区名称",
          trigger: "blur",
        },
        five_company_id: {
          required: true,
          message: "请选择5.0景区",
          trigger: "blur",
        },
        provinceCode: [
          { 
            validator: (rule, value, callback) => {
              // if (!this.dialogForm.provinceCode || !this.dialogForm.cityCode || !this.dialogForm.districtCode) {
              if (!this.dialogForm.provinceCode || !this.dialogForm.cityCode) {
                callback(new Error("请完整选择省市区"))
              } else {
                callback();
              }
            }, trigger: 'change'
          }
        ]
      },
      activeNames: "0",
      dialogVisible: false, // 模态框是否展示
      dialogForm: {
        five_company_id: null,
        company_name: '',
        app_map: '',
        provinceCode: '',
        cityCode: '',
        districtCode: '',
      }, // 模态框展示的数据
      provinceList: [],
      cityList: [],
      areaList: [],
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
      polygon: [],
      drawingManager: null,
      remark: null,
      geoc: null,
      type: '',
      id: null,
      storeList: [],
      polygonAreas: null,
      location:  null,
      boundary: [],
      pointMark: null,
    };
  },
  created() {
    console.log(this.province)
    this.type = this.$route.query.type
    // this.storeList = JSON.parse(this.$route.query.storeList)
    this.storeList = JSON.parse(sessionStorage.getItem('scenicStore'))
    if(this.type == 'edit'){
      // let param = JSON.parse(this.$route.query.row)
      let param = JSON.parse(sessionStorage.getItem('scenic'))
      this.dialogForm.company_name = param.companyName
      this.dialogForm.five_company_id = param.five_company_id
      this.dialogForm.provinceCode = param.address
      this.dialogForm.cityCode = param.city
      this.cityList = this.province.filter(item => item.provice == param.address)[0].citys
      let polygon = []
      JSON.parse(param.location_list).forEach(item => {
        polygon.push({
          lng: item.lon,
          lat: item.lat
        })
      })
      this.polygon = polygon
      this.id = param.id
      this.mapCenter = param.location.split(',')
      this.$nextTick(() => {
        this.drawMapArea()
      })
    }
  },
  mounted() {},

  methods: {
    provinceChange(item,type){
      if(!item) return
      this.cityList = item.citys
      this.dialogForm.provinceName=item.province
      if(!type) this.crealt()
      this.$refs.dialogForm.validateField("provinceCode")
    },
    cityChange(item,type){
      console.log(item, type)
      if(!item) return
      this.areaList=item.areas
      this.dialogForm.cityName=item.city
      this.getMapCity(item.name)
     if(!type) this.dialogForm.districtCode=null
     this.$refs.dialogForm.validateField("provinceCode")
    },
    changeDistrict(item){
      this.dialogForm.districtName = item.area
    },
    initProvince(val){
      if(!val){
        this.cityList=[]
        this.areaList=[]
        this.crealt()
      }
    },
    initCity(val){
      if(!val){
        this.areaList=[]
        this.dialogForm.districtCode=null
      }
    },
    crealt(){
      this.dialogForm.cityCode=null
      this.dialogForm.districtCode=null
    },

    getMap1AreaSt(){
      let that = this
      this.geoc = new BMap.Geocoder()
      this.drawingManager = new BMapLib.DrawingManager(window.map1, {
        isOpen: true,
        drawingMode: BMAP_DRAWING_POLYGON,
        enableDrawingTool: false,
        drawingToolOptions: {
          anchor: BMAP_ANCHOR_TOP_RIGHT,
          offset: new BMap.Size(5, 5)
        },
        polygonOptions: {
          strokeColor: "#96e1fa",  // 边框颜色（红色）
          fillColor: "#1e90ff",    // 填充颜色
          strokeWeight: 2,         // 边框粗细（像素）
          strokeOpacity: 0.8,      // 边框透明度（0-1）
          fillOpacity: 0.6         // 填充透明度
        }
      });
      // 监听绘制完成事件
      this.drawingManager.addEventListener('polygoncomplete', (e) => {
        this.polygon = e.getPath();
        console.log('坐标', this.polygon)
        window.map1.removeOverlay(this.remark)
        this.remark = e
        if(this.polygonAreas)window.map1.removeOverlay(this.polygonAreas)
        this.getMap1AreaSt()
      })
    },
    drawMapArea(){
      let points = []
      this.polygon.forEach(item => {
        points.push(new BMap.Point(item.lng, item.lat))
      })
      let polygon = new BMap.Polygon(points, {
        strokeColor: "#96e1fa",
        strokeWeight: 2,
        strokeOpacity: 0.8,
        fillColor: "#1e90ff",
        fillOpacity: 0.6
      })
      
      this.polygonAreas = polygon
      window.map1.addOverlay(polygon)
    },
    getMap1Point(){
      if(!this.dialogForm.app_map) return
      // this.geoc.getPoint(this.dialogForm.app_map, function(point) {
      //   if (point) {
      //     window.map1.centerAndZoom(point, 17);
      //   } else {
      //     alert("未找到该地址，请尝试更详细的信息");
      //   }
      // }, "全国"); // "全国"是可选参数，指定搜索范围
      
      this.getMapCity(this.dialogForm.app_map)
    },
    getMapCity(address){
      if(this.boundary){
        this.boundary.forEach(item => {
          window.map1.removeOverlay(item)
        })
        this.boundary = []
      }
      if(this.pointMark){
        window.map1.removeOverlay(this.pointMark)
        this.pointMark = null
      }
      let that = this
      // 可能有多个边界（如岛屿）
      var bdary = new BMap.Boundary()
      bdary.get(address, function(rs) {
        if (rs.boundaries.length === 0) {
            that.getLocal()
            return;
        }
        var points = [];
        for (var i = 0; i < rs.boundaries.length; i++) {
            var ply = new BMap.Polygon(rs.boundaries[i], {
                strokeWeight: 2,
                strokeOpacity: 1,
                strokeColor: "#ff0000",
                fillColor: "#f2f2f2",
                fillOpacity: 0.5
            });
            window.map1.addOverlay(ply)
            that.boundary.push(ply)
            // 获取边界点坐标
            var path = ply.getPath();
            for (var j = 0; j < path.length; j++) {
                points.push({
                    lng: path[j].lng,
                    lat: path[j].lat
                });
            }
            // 自动调整视图
            window.map1.setViewport(ply.getBounds())
        }
        window.map1.setZoom(10)
      })
    },
    getLocal(){
      let that = this
      let localSearch = new BMap.LocalSearch(window.map1)
      localSearch.search(this.dialogForm.app_map);
      localSearch.setSearchCompleteCallback(function(rs){
          if(localSearch.getStatus() == BMAP_STATUS_SUCCESS){
              var firstResult = rs.getPoi(0);
              window.map1.centerAndZoom(firstResult.point, 16);
              let pointMark = new BMap.Marker(firstResult.point)
              window.map1.addOverlay(pointMark)
              that.pointMark = pointMark
          }
      })
    },
    handleAdd() {
      this.$router.push("/scenicList");
    },
    // 点击退款按钮，弹出弹窗
    handleManualRefund(row, index) {
      this.dialogVisible = true;
    },
    reset(){
      this.$router.go(-1)
    },
    submitForm() {
      if(this.polygon.length == 0){
        this.$message({
          message: '请在地图上选择区域',
          type: 'warning'
        })
        return
      }
      let center = window.map1.getCenter()
      if(this.type == 'add'){
        let location_list = []
        this.polygon.forEach(item => {
          location_list.push({
            lat: item.lat,
            lon: item.lng
          })
        });
        let param = {
          company_name: this.dialogForm.company_name,
          five_company_id: this.dialogForm.five_company_id,
          location_list: location_list,
          location: center.lng + ',' + center.lat,
          address: this.dialogForm.provinceCode,
          city: this.dialogForm.cityCode
        }
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              createCompany(param).then(res => {
                if(res && res.data){
                  this.$router.go(-1)
                }
              })
            })
          }
        })
      } else {
        let location_list = []
        this.polygon.forEach(item => {
          location_list.push({
            lat: item.lat,
            lon: item.lng
          })
        });
        let param = {
          id: this.id,
          company_name: this.dialogForm.company_name,
          five_company_id: this.dialogForm.five_company_id,
          location_list: location_list,
          location: center.lng + ',' + center.lat,
          address: this.dialogForm.provinceCode,
          city: this.dialogForm.cityCode
        }
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              updateCompany(param).then(res => {
                if(res && res.data){
                  this.$message.success('修改成功')
                  this.$router.go(-1)
                }
              })
            })
          }
        })
      }
      
    },
  },
  beforeDestroy() {
    window.map1.removeOverlay(this.remark)
    this.drawingManager = null
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: 700;
}
.titlas {
  display: flex;
  align-items: center;
  margin: 20px 0;
}
.setCity {
  .el-select{
    margin-right: 20px;
  }
}
.tips {
  color: red;
  font-size: 16px;
  font-weight: 600;
}
.map{
  width: 500px;
  height: 500px;
  position: relative;
  margin: 30px 0 30px 40px;
}
</style>
